
/* injects from baggage-loader */
var Template = require('./template.js');

import React from 'react';
import { connect } from 'react-redux';
import {createSelector} from 'reselect';
import {UIMixin} from '../../../../../dev/mixins/uiMixin';
import {SwarmDataMixin} from '../../../../../dev/mixins/swarmDataMixin';
import {TOGGLE_VIRTUAL_KEYBOARD} from "../../../../../dev/actions/actionTypes";
import Zergling from '../../../../helpers/zergling';
import Config from '../../../../../dev/config/main';

class BetIdEnter extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            betId: '',
            eventId: {},
            errMsg: ''
        };

        this.betIdInput = React.createRef();

        this.hendlerChangeBetId = this.hendlerChangeBetId.bind(this);
        this.betIdClick = this.betIdClick.bind(this);
        this.openKeyBoard = this.openKeyBoard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    hendlerChangeBetId (value) {
        this.setState({ betId: value });
    }
    betIdClick (e) {
        if (!this.props.ui.showVirtualKeyBoard) {
            this.openKeyBoard(this.state.betId, this.hendlerChangeBetId, () => { console.log('onOpenCallback'); }, () => { console.log('onCloseCallback'); }, undefined, e);
        }
    }
    componentDidUpdate (prevProps) {
        const { hidden } = this.props;
        const { errMsg } = this.state;
        if (prevProps.hidden !== hidden && errMsg) this.setState({ errMsg: '' });
    }
    onSubmit () {
        let apiUrl
        const params = {}

        if (Config.main.useBetBookLastApi) {
            params.Id = +this.state.betId
            apiUrl = 'terminal_get_bet_by_bet_book_id_v2'
        } else {
            apiUrl = 'terminal_get_bet_by_bet_book_id'
            params.id = +this.state.betId
            params.token = JSON.parse(sessionStorage.getItem("authData")).token
        }

        (Zergling.get(params, apiUrl)).then(selections => {
            if (typeof selections.data === 'string') {
                this.setState({
                    errMsg: selections.data
                });
            } else {
                this.props.setSelectionIds(selections);
            }
        });
        this.setState({betId: ''});
        this.betIdInput.current.innerText = '';
        this.setState({
            errMsg: ''
        });
    }
    openKeyBoard (currentValue, changeHandler, onOpenCallback, onCloseCallback, bet, e) {
        this.keyboardSettings = {
            currentValue,
            changeHandler,
            onOpenCallback,
            onCloseCallback,
            bet,
            e,
            processHandler: (stake) => stake,
            offset: e.target.offsetTop
        };
        setTimeout(() => {
            this.props.dispatch({type: TOGGLE_VIRTUAL_KEYBOARD, payload: true});
        });
    }
    render () {
        return Template.default.apply(this);
    }
}
const mapStateToProps = () => {
    return createSelector(
        [
            state => state.uiState
        ],
    (ui) => ({ui}));
};
export default connect(mapStateToProps)(SwarmDataMixin({Component: UIMixin({Component: BetIdEnter})}));